const V = {
  name: "HongKong2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1.4648V0H11V6.4648L5 10.4648V22H2V24H22V22H19V5.4648L13 1.4648ZM13 22V21.5352L17 18.8685V22H13ZM13.0528 11.5L17 8.86855V14.1315L13.0528 11.5ZM13 13.8685L16.9472 16.5L13 19.1315V13.8685ZM16.9473 6.50001L13 9.13151V3.8685L16.9473 6.50001ZM7.05279 11.5L11 8.86854V14.1315L7.05279 11.5ZM7 19.1315V13.8685L10.9472 16.5L7 19.1315ZM7 21.5352L11 18.8685V22H7V21.5352Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as HongKong2
};
